package com.eladfinish.bible.contest.screens.main.ui.dialogs

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ad_free_for_minutes_action
import com.eladfinish.bible.contest.ads.AdFreeReward
import com.eladfinish.bible.contest.rewarded_ad_dialog_content
import com.eladfinish.bible.contest.screens.main.MainScreenAction
import com.eladfinish.bible.contest.screens.main.MainScreenState
import com.eladfinish.bible.contest.screens.main.data.ButtonType
import com.eladfinish.bible.contest.screens.main.data.toStringResource
import com.eladfinish.bible.contest.screens.main.ui.AboutPageContent
import com.eladfinish.bible.contest.screens.mikud.ui.dialogs.SimpleMessageDialog
import com.eladfinish.bible.contest.support_ad_dialog_content
import com.eladfinish.bible.contest.supporting_the_app
import com.mohamedrejeb.richeditor.model.rememberRichTextState
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditor
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditorDefaults
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.compose.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun MainScreenDialogs(
    logEvent: (String) -> Unit,
    dialogState: MainScreenState.DialogState,
    onAction: (MainScreenAction) -> Unit,
) {
    when (dialogState) {
        MainScreenState.DialogState.None -> Unit

        is MainScreenState.DialogState.Help -> {
            MainScreenDialogContainer(
                titleResource = ButtonType.HELP.toStringResource(),
                onDismiss = {
                    onAction(MainScreenAction.HideDialog)
                },
            ) {
                val text = dialogState.content

                val richTextState = rememberRichTextState()
                RichTextEditor(
                    modifier = Modifier
                        .fillMaxWidth(),
                    state = richTextState,
                    readOnly = true,
                    colors = RichTextEditorDefaults.richTextEditorColors(
                        containerColor = Color.White
                    ),
                )

                LaunchedEffect(text) {
                    richTextState.setMarkdown(text)
                }
            }
        }

        is MainScreenState.DialogState.About -> {
            MainScreenDialogContainer(
                titleResource = ButtonType.ABOUT.toStringResource(),
                onDismiss = {
                    onAction(MainScreenAction.HideDialog)
                },
            ) {
                AboutPageContent(
                    appInfo = dialogState.appInfo,
                    aboutTerumaUiModel = dialogState.aboutTerumaUiModel,
                    logEvent = logEvent,
                )
            }
        }

        is MainScreenState.DialogState.DebugStuff -> {
            SimpleMessageDialog(
                onDismiss = {
                    onAction(MainScreenAction.HideDialog)
                },
                title = dialogState.title.localized(),
                content = dialogState.content,
            )
        }

        MainScreenState.DialogState.ConfirmSupportAd -> {
            ConfirmAdDialog(
                onAction = onAction,
                title = stringResource(SharedRes.strings.supporting_the_app),
                content = stringResource(SharedRes.strings.support_ad_dialog_content),
                onConfirm = { onAction(MainScreenAction.ConfirmedSupportAd) }
            )
        }

        MainScreenState.DialogState.ConfirmRewardedAd -> {
            ConfirmAdDialog(
                onAction = onAction,
                title = stringResource(SharedRes.strings.ad_free_for_minutes_action, AdFreeReward.MINUTES),
                content = stringResource(SharedRes.strings.rewarded_ad_dialog_content, AdFreeReward.MINUTES),
                onConfirm = { onAction(MainScreenAction.ConfirmedRewardedAd) }
            )
        }

        MainScreenState.DialogState.RewardEarnedUpsell -> {
            RewardEarnedUpsellDialog(onAction = onAction)
        }
    }
}
